<template>
  <div>
    <!-- <h2 class="text-center colorblue">Настройки калькулятора</h2> -->
    <!-- <v-btn
      class="mb-2"
      @click="MakeBackup"
      style="position: absolute; top: 35px; right: 17px; z-index: 9999"
      :disabled="backupDisabled"
    >
      <v-icon>mdi-call-split</v-icon>{{ backUpText }}
    </v-btn> -->
    <!-- <p>{{ backupMessage }}</p> -->
    <v-card>
      <v-tabs v-model="tab" @change="changeTab" centered>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>
    <v-card>
      <v-tabs-items v-model="tab" class="mt-2">
        <v-tab-item>
          <v-card-text>
            <BanksTable />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <ProductsTable />
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import BanksTable from "./calcsettings/banksTable.vue";
import ProductsTable from "./calcsettings/productsTable.vue";

export default {
  components: {
    BanksTable,
    ProductsTable,
  },
  data: () => ({
    tab: 1,
    items: [
      "Банки",
      "Банковские продукты",
    ],
    backUpText: "Сделать бекап",
    backupDisabled: false,
    backupMessage: "",
  }),

  methods: {
    changeTab() {
      this.$store
        .dispatch("ChangeTab", this.tab)
        .then(() => { })
        .catch((error) => {
          alert(error);
        });
    },
    async MakeBackup() {
      let dot = "";
      const interval = setInterval(() => {
        if (dot == "...") {
          dot = "";
        } else {
          dot += ".";
        }
        this.backUpText = `Идет процесс ${dot}`;
      }, 500);
      this.backupDisabled = true;
      const data = await this.$store.dispatch("MAKE_BACKUP");
      this.backUpText = data.message;
      setTimeout(() => {
        this.backUpText = "Сделать бекап";
      }, 3000);
      clearInterval(interval);
      this.backupDisabled = false;
    },
  },
  computed: {},
  async mounted() {
    this.setTitle("Настройки Банка / Агрегатора");
    this.tab = this.$store.getters.GetCalcSettingsTab;
    if (!this.$store.getters.getBanksCS.length) {
      await this.$store.dispatch("GetCalcSettingsCS")
    }
  },
  //getCalculatorSettingsSimple
};
</script>

<style lang="sass"></style>
